function convertMetersToMiles(meters: number, precision = 1) {
  return parseFloat((meters * 0.000621371192).toFixed(precision));
}

function getRouteDistance(route: { distance: number; waypoints?: { distance: number }[] }) {
  return route.waypoints?.length
    ? route.waypoints.reduce((total, waypoint) => total + waypoint.distance, 0)
    : route.distance;
}

function getDisplayDistance(meters: number, preferredUnits: string) {
  if (preferredUnits === 'feet') {
    return meters < 152.4
      ? { distance: Math.round(meters / 0.3048), unit: 'feet' as const }
      : { distance: Math.round((meters / 1609.344) * 10) / 10, unit: 'miles' as const };
  }

  return meters < 1000
    ? { distance: Math.round(meters), unit: 'meters' as const }
    : { distance: Math.round(meters / 100) / 10, unit: 'kilometers' as const };
}

function formatDirectionsDistance(
  meters: number,
  preferredUnits: string,
  T: (key: string, options: Record<string, number>) => string,
) {
  const { distance, unit } = getDisplayDistance(meters, preferredUnits);
  switch (unit) {
    case 'feet':
      return T('getDirectionsFromTo:_distance_feet', { distance });
    case 'miles':
      return T('getDirectionsFromTo:_miles_ mi', { miles: distance });
    case 'kilometers':
      return T('getDirectionsFromTo:_distance_km', { distance });
    case 'meters':
      return T('getDirectionsFromTo:_distance_ m', { distance });
  }
}

export { convertMetersToMiles, getRouteDistance, getDisplayDistance, formatDirectionsDistance };
